import { Component, ViewChild } from '@angular/core';
import { UserLabelConstants } from '../../../constants/LabelConstants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../../common/api-url-helper';
import { CommonService } from '../../../services/common/common.service';
import { SharedService } from '../../../services/shared-service/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordSuccessPopup } from '../../../component/forgot-password-success-popup/forgot-password-success-popup';
import { RecaptchaWidgetComponent } from '../../../component/recaptcha-widget/recaptcha-widget';
import { CaptchaService } from '../../../services/captcha-service/captcha.service';

@Component({
  selector: 'app-forgot-password',
  standalone: false,
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  forgotPassWordForm: FormGroup | any;
  submitted: boolean = false;
  isShowPassword: boolean = false;
  isCaptchaVerified: boolean = false;
  userDetails: any
  year: any = new Date().getFullYear();
  @ViewChild('recaptchaWidget') recaptchaWidget?: RecaptchaWidgetComponent;

  constructor(
    private sharedService: SharedService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private router: Router,
    private api: ApiUrlHelper,
    private readonly dialog: MatDialog,
    public readonly captchaService: CaptchaService
  ) { }

  ngOnInit(): void {
    this.forgotPassWordForm = this.fb.group({
      UserEmail: ['', [Validators.required, Validators.email, Validators.pattern(/^(?=.{1,30}@)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]]
    })
    this.sharedService.setData(UserLabelConstants.ForgotPassword);
    this.isCaptchaVerified = !this.captchaService.isEnabled();
  }

  onCaptchaResolved(): void {
    this.isCaptchaVerified = true;
  }

  onCaptchaExpired(): void {
    this.isCaptchaVerified = false;
  }

  get loginFormControls() {
    return this.forgotPassWordForm?.controls;
  }

  submitForgotPassForm() {
    this.submitted = true;
    if (this.forgotPassWordForm.invalid) {
      return;
    }

    if (this.captchaService.isEnabled() && !this.recaptchaWidget?.hasValidToken()) {
      this.toastr.error('Please complete the security verification.');
      return;
    }

    this.submitted = false;
    this.spinner.show();
    let api = this.api.apiUrl.Account.ForgetPassword;
    const email = this.forgotPassWordForm.value.UserEmail.toLowerCase().trim();
    const objData = {
      Email: email,
      CaptchaToken: this.recaptchaWidget?.getToken() ?? ''
    };
    
    this.commonService.doPost(api, objData).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          const dialogRef = this.dialog.open(ForgotPasswordSuccessPopup, {
            width: '500px',
            data: { emailId: email },
            disableClose: true
          });
          dialogRef.afterClosed().subscribe();
          this.forgotPassWordForm.reset();
        }
        else {
          this.spinner.hide();
          this.recaptchaWidget?.reset();
          this.toastr.error(response.message);
        }
      }, error: (err: any) => {
        this.spinner.hide();
        console.error(err);
      }
    })
  }

  trimInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const trimmedValue = input.value.trim();
    const controlName = input.getAttribute('formControlName');
    if (controlName && this.loginFormControls[controlName]) {
      this.loginFormControls[controlName].setValue(trimmedValue, { emitEvent: false });
    }
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }
}